import React from "react";
import { Box, Paper, Step, StepLabel, Stepper } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { WORKFLOW_STEPS } from "../../constants/workflowSteps";

export default function WorkflowStepper({ activeStep = 0 }) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 40,
        bgcolor: "background.default",
        // borderBottom: 1,
        // borderColor: "divider",
        boxShadow: "0 6px 20px rgba(0, 0, 0, 0.09)"
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 0,
          bgcolor: "background.paper",
        //   borderBottom: "1px solid",
        //   borderColor: "divider",
        }}
      >
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          sx={{
            px: { xs: 1, sm: 2, md: 3 },
            py: 1.5,
            overflowX: "auto",
            "& .MuiStepConnector-line": {
              borderColor: "grey.300",
            },
            "& .MuiStepLabel-label": {
              color: "text.secondary",
              fontSize: { xs: "0.72rem", sm: "0.8rem" },
            },
            "& .MuiStepLabel-label.Mui-active": {
              color: "primary.main",
              fontWeight: 700,
            },
            "& .MuiStepLabel-label.Mui-completed": {
              color: "success.main",
              fontWeight: 600,
            },
            "& .MuiStepIcon-root": {
              color: "grey.300",
            },
            "& .MuiStepIcon-root.Mui-active": {
              color: "primary.main",
            },
            "& .MuiStepIcon-root.Mui-completed": {
              color: "success.main",
            },
          }}
        >
          {WORKFLOW_STEPS.map((label, i) => (
            <Step key={label}>
              {/* The step right after the current one carries a lock so the
                  user can see it is not reachable yet, rather than merely
                  upcoming. */}
              <StepLabel
                icon={
                  i === activeStep + 1 ? (
                    <LockOutlinedIcon sx={{ fontSize: 22, color: "grey.400" }} />
                  ) : undefined
                }
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>
    </Box>
  );
}
